import React, { Component } from "react";
import { connect } from "react-redux";
import BaseSelectField, { getOptionValue, getValue } from "../../../Base/ui/inputs/SelectField";
import updateAssociationName from "../helpers/update_association_name";

class SelectField extends Component {
  handleChange(resource, option) {
    this.props.handleChange(this.props.name, option ? option.value : null, resource);
  }

  render() {
    const { resource, name, label, col, action, optionValue, options=[], value} = this.props;
    return(
      <BaseSelectField 
        value={value}
        optionValue={optionValue}
        options={options}
        onChange={this.handleChange.bind(this, resource)}
        resource={resource}
        name={name}
        label={label}
        col={col}
        action={action}
        {...this.props} />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { resource = "affiliateMemberDetail", name, options } = ownProps;

  return {
    action: ownProps.action || state.ui.action,
    value: state[resource] === null ? '' : state[resource][name],
    optionValue: getOptionValue(state, ownProps),
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleChange: (name, value, resource) => dispatch({type: `UPDATE_${updateAssociationName(resource)}`, payload: {name, value}})
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectField);
